import { render, staticRenderFns } from "./ProposeChangesToActiveMicrolearningDialog.vue?vue&type=template&id=37dfeb05&scoped=true"
import script from "./ProposeChangesToActiveMicrolearningDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposeChangesToActiveMicrolearningDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProposeChangesToActiveMicrolearningDialog.vue?vue&type=style&index=0&id=37dfeb05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfeb05",
  null
  
)

export default component.exports